import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { OverlayTrigger, Popover, Tooltip } from "react-bootstrap";
import { toast } from "react-toastify";
import { LoadingScreen, UserHover } from "Components";
import { CreateRole } from "./CreateRole";
import { authService } from "Service/Axios";
import { convertLinkObjectListToJoin, getFirstLetterOfName } from "Utils";
import { DELETE_ADMIN_ROLE_URL } from "Constant/api";
import { useRoleList } from "Constant/apiHooks";

export const Roles = () => {
  const { t } = useTranslation();

  const [showCreateRole, setShowCreateRole] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);

  const { roleList, loading: roleLoading, fetchRoleList } = useRoleList();

  // Toggle
  const toggleCreateRole = (role) => {
    if (role) {
      setSelectedRole(role);
    } else {
      setSelectedRole(null);
    }
    setShowCreateRole(!showCreateRole);
  };

  const onDeleteRole = async (gid) => {
    try {
      const data = {
        gid,
      };
      const response = await authService(DELETE_ADMIN_ROLE_URL, "POST", data);
      if (response.success) {
        fetchRoleList();
        toast.success(t("common.messages.notification.success.deleteRole"));
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(t("common.messages.notification.failed.somethingWentWrong"));
    }
  };
  return (
    <div className="roles">
      <div className="d-flex align-items-center mb-3">
        <h4 className="admin-sub-title">{t("common.button.roles")}</h4>
        <div className="ms-auto">
          <button
            className="btn btn-primary"
            type="button"
            onClick={() => toggleCreateRole()}
          >
            <i className="bx bx-plus"></i> {t("common.button.createRole")}
          </button>
        </div>
      </div>
      <div className="table-container mb-4 max-h-700">
        <table className="table table-bordered">
          <thead className="table-light position-sticky top-0 z-20">
            <tr>
              <th>{t("common.label.name")}</th>
              <th>{t("common.label.users")}</th>
              <th>{t("common.label.attribute")}</th>
              <th className="text-center">{t("common.label.action")}</th>
            </tr>
          </thead>
          <tbody>
            {roleLoading ? (
              <tr className="loading-screen">
                <td colSpan={4}>
                  <LoadingScreen />
                </td>
              </tr>
            ) : (
              roleList &&
              roleList.length > 0 &&
              roleList.map((role) => (
                <tr key={role.gid}>
                  <td>
                    {["top"].map((placement) => (
                      <OverlayTrigger
                        key={placement}
                        placement={placement}
                        overlay={
                          <Tooltip id={`tooltip-${placement}`}>
                            {role.description}
                          </Tooltip>
                        }
                      >
                        <span>{role.name} </span>
                      </OverlayTrigger>
                    ))}
                  </td>
                  <td>
                    <div className="position-relative">
                      {role.users &&
                        role.users.length > 0 &&
                        role.users.slice(0, 2).map((user, index) => (
                          <div
                            className="assignee_img applicant-dropdown roles-img"
                            key={`${user.firstName}${index}`}
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Popover className="max-w-unset">
                                  <UserHover user={user} />
                                </Popover>
                              }
                            >
                              <div className="d-flex align-items-center">
                                <div className="w-8 h-8 rounded-circle overflow-hidden">
                                  {user.photoURL ? (
                                    <div className="img-box w-100 h-100">
                                      <img
                                        src={user.photoURL}
                                        alt={`${user.firstName} ${user.lastName}`}
                                        className="w-100 h-100 object-fit-cover"
                                      />
                                    </div>
                                  ) : (
                                    getFirstLetterOfName(user)
                                  )}
                                </div>
                              </div>
                            </OverlayTrigger>
                          </div>
                        ))}
                    </div>
                  </td>
                  <td>
                    {role.attributes &&
                      convertLinkObjectListToJoin(role.attributes)}
                  </td>
                  <td>
                    <>
                      <div className="d-flex justify-content-center align-items-center gap-1">
                        <button
                          type="button"
                          className="button edit btn btn-transparent px-1 text-green-500"
                          onClick={() => toggleCreateRole(role)}
                        >
                          <i className="bx bxs-pencil"></i>
                        </button>
                        <button
                          type="button"
                          className="button delete btn btn-transparent px-1 text-red-500"
                          onClick={() => onDeleteRole(role.gid)}
                        >
                          <i className="bx bx-trash"></i>
                        </button>
                      </div>
                    </>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {showCreateRole && (
        <CreateRole
          show={showCreateRole}
          selectedData={selectedRole}
          toggle={toggleCreateRole}
          fetchList={fetchRoleList}
        />
      )}
    </div>
  );
};
